import { Injectable } from '@angular/core';

@Injectable()
export class ErrorStackService {

  errors;
  constructor() {
      this.errors = [];
  }
  log(error): void {
    console.error(error);
  }
  append(error, log: boolean): void {
      if(error !== null && typeof error !== 'undefined'){
          if(log){
            this.log(error);
          }
          this.errors.push(error);
      }
  }
  getErrors(): string[] {
      return this.errors.map(error => error.toString());
  }

}



// WEBPACK FOOTER //
// ./src/app/error-stack.service.ts